// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BottomControlsController from "./bottom_controls_controller"
application.register("bottom-controls", BottomControlsController)

import Bridge__FileDownloadController from "./bridge/file_download_controller"
application.register("bridge--file-download", Bridge__FileDownloadController)

import Bridge__LocalizeController from "./bridge/localize_controller"
application.register("bridge--localize", Bridge__LocalizeController)

import Bridge__MenuButtonController from "./bridge/menu_button_controller"
application.register("bridge--menu-button", Bridge__MenuButtonController)

import Bridge__ShareController from "./bridge/share_controller"
application.register("bridge--share", Bridge__ShareController)

import Bridge__SignOutController from "./bridge/sign_out_controller"
application.register("bridge--sign-out", Bridge__SignOutController)

import Bridge__ThemeController from "./bridge/theme_controller"
application.register("bridge--theme", Bridge__ThemeController)

import CloudflareTurnstileController from "./cloudflare_turnstile_controller"
application.register("cloudflare-turnstile", CloudflareTurnstileController)

import CropperjsController from "./cropperjs_controller"
application.register("cropperjs", CropperjsController)

import DesktopDownloadController from "./desktop_download_controller"
application.register("desktop-download", DesktopDownloadController)

import FileDownloadController from "./file_download_controller"
application.register("file-download", FileDownloadController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import RubyUi__CarouselController from "./ruby_ui/carousel_controller"
application.register("ruby-ui--carousel", RubyUi__CarouselController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__DismissAlertController from "./ruby_ui/dismiss_alert_controller"
application.register("ruby-ui--dismiss-alert", RubyUi__DismissAlertController)

import RubyUi__DropdownMenuController from "./ruby_ui/dropdown_menu_controller"
application.register("ruby-ui--dropdown-menu", RubyUi__DropdownMenuController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__SelectController from "./ruby_ui/select_controller"
application.register("ruby-ui--select", RubyUi__SelectController)

import RubyUi__SelectItemController from "./ruby_ui/select_item_controller"
application.register("ruby-ui--select-item", RubyUi__SelectItemController)

import RubyUi__SheetContentController from "./ruby_ui/sheet_content_controller"
application.register("ruby-ui--sheet-content", RubyUi__SheetContentController)

import RubyUi__SheetController from "./ruby_ui/sheet_controller"
application.register("ruby-ui--sheet", RubyUi__SheetController)

import RubyUi__TabsController from "./ruby_ui/tabs_controller"
application.register("ruby-ui--tabs", RubyUi__TabsController)

import RubyUi__ThemeToggleController from "./ruby_ui/theme_toggle_controller"
application.register("ruby-ui--theme-toggle", RubyUi__ThemeToggleController)

import RubyUi__TooltipController from "./ruby_ui/tooltip_controller"
application.register("ruby-ui--tooltip", RubyUi__TooltipController)

import SearchAutoSubmitController from "./search_auto_submit_controller"
application.register("search-auto-submit", SearchAutoSubmitController)

import SyncDirectionController from "./sync_direction_controller"
application.register("sync-direction", SyncDirectionController)

import SyncValueController from "./sync_value_controller"
application.register("sync-value", SyncValueController)

import TextRotationController from "./text_rotation_controller"
application.register("text-rotation", TextRotationController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TopControlsController from "./top_controls_controller"
application.register("top-controls", TopControlsController)
